import React, { Component, type JSX } from 'react';

/**
 * Render the 4 placeholder cards while fetching the tutor
 * locations from the backend.
 */
export class SearchBijlesLoading extends Component {

  public render(): JSX.Element {
    return (
      <div className="mt-4 mb-5 container">
        <div className="row">
          <BijlesLoadingItem/>
          <BijlesLoadingItem/>
          <BijlesLoadingItem/>
          <BijlesLoadingItem/>
        </div>
      </div>
    );
  }
}

/**
 * A single gray card with loading animation.
 */
export class BijlesLoadingItem extends Component {

  public render(): JSX.Element {
    const styleItem = {
      width: '100%',
      height: '350px',
      backgroundColor: '#f2f2f2',
      borderRadius: '8px',
    };

    return (
      <div className="col-md-3">
        <div className="c-placeholder__line" style={styleItem}/>
      </div>
    );
  }
}

